<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect style="fill: #ffffff" width="200" height="200" />
    <path
      style="fill: #cf649a"
      d="M136.4,105.6c-3.5,0-6.6,0.9-9.1,2.1c-0.9-1.9-1.9-3.5-2-4.7c-0.2-1.4-0.4-2.3-0.2-4
	c0.2-1.7,1.2-4.1,1.2-4.3c0-0.2-0.2-1-2.2-1.1c-2,0-3.8,0.4-4,0.9s-0.6,1.8-0.8,3c-0.4,1.9-4.1,8.4-6.2,11.9
	c-0.7-1.3-1.3-2.5-1.4-3.5c-0.2-1.4-0.4-2.3-0.2-4c0.2-1.7,1.2-4.1,1.2-4.3c0-0.2-0.2-1-2.2-1.1c-2,0-3.8,0.4-4,0.9s-0.4,1.8-0.8,3
	c-0.4,1.2-5.3,12.2-6.6,15c-0.7,1.5-1.2,2.6-1.6,3.4c-0.4,0.8,0,0.1-0.1,0.1c-0.4,0.7-0.6,1-0.6,1v0c-0.3,0.5-0.6,1-0.7,1
	c-0.1,0-0.3-1.3,0-3.1c0.7-3.8,2.5-9.7,2.5-9.9c0-0.1,0.3-1.1-1.1-1.7c-1.4-0.5-2,0.4-2.1,0.4c-0.1,0-0.2,0.3-0.2,0.3
	s1.6-6.7-3.1-6.7c-2.9,0-6.9,3.2-8.9,6.1c-1.3,0.7-3.9,2.1-6.8,3.7c-1.1,0.6-2.2,1.2-3.3,1.8l-0.2-0.2c-5.6-6-16.1-10.3-15.6-18.3
	c0.2-2.9,1.2-10.7,20-20.1c15.4-7.7,27.8-5.6,29.9-0.9c3.1,6.7-6.6,19.1-22.6,20.9c-6.1,0.7-9.3-1.7-10.1-2.6c-0.8-0.9-1-1-1.3-0.8
	c-0.5,0.3-0.2,1.1,0,1.6c0.5,1.2,2.4,3.4,5.8,4.6c2.9,1,10.1,1.5,18.8-1.9c9.7-3.8,17.3-14.2,15.1-22.9c-2.3-8.9-17-11.8-30.9-6.9
	c-8.3,3-17.3,7.6-23.7,13.6c-7.7,7.2-8.9,13.4-8.4,16c1.8,9.3,14.6,15.3,19.7,19.8c-0.3,0.1-0.5,0.3-0.7,0.4
	c-2.6,1.3-12.3,6.4-14.8,11.8c-2.8,6.1,0.4,10.5,2.6,11.1c6.6,1.8,13.3-1.5,17-6.9c3.6-5.4,3.2-12.5,1.5-15.7l-0.1-0.1l2-1.2
	c1.3-0.8,2.6-1.5,3.7-2.1c-0.6,1.7-1.1,3.7-1.3,6.7c-0.3,3.5,1.1,8,3,9.7c0.8,0.8,1.8,0.8,2.4,0.8c2.2,0,3.2-1.8,4.2-3.9
	c1.3-2.6,2.5-5.7,2.5-5.7s-1.5,8.2,2.6,8.2c1.5,0,3-1.9,3.6-2.9v0c0,0,0-0.1,0.1-0.2c0.1-0.1,0.2-0.2,0.2-0.4v0
	c0.6-1,1.9-3.4,3.9-7.2c2.5-5,5-11.3,5-11.3s0.2,1.5,1,4.1c0.4,1.5,1.4,3.1,2.1,4.7c-0.6,0.8-0.9,1.3-0.9,1.3l0,0
	c-0.5,0.6-1,1.3-1.6,2c-2,2.4-4.4,5.1-4.7,5.9c-0.4,0.9-0.3,1.6,0.4,2.2c0.5,0.4,1.5,0.5,2.5,0.4c1.8-0.1,3.1-0.6,3.7-0.8
	c1-0.4,2.1-0.9,3.2-1.7c2-1.5,3.2-3.5,3.1-6.3c-0.1-1.5-0.6-3-1.2-4.4c0.2-0.3,0.4-0.5,0.5-0.8c3.1-4.6,5.5-9.6,5.5-9.6
	s0.2,1.5,1,4.1c0.4,1.3,1.1,2.7,1.8,4.1c-2.9,2.4-4.7,5.1-5.4,7c-1.2,3.3-0.3,4.9,1.5,5.2c0.8,0.2,1.9-0.2,2.7-0.6
	c1-0.3,2.3-0.9,3.4-1.8c2-1.5,3.9-3.5,3.8-6.2c-0.1-1.3-0.4-2.5-0.8-3.7c2.5-1,5.7-1.6,9.8-1.1c8.8,1,10.5,6.5,10.2,8.8
	c-0.3,2.3-2.2,3.5-2.8,3.9c-0.6,0.4-0.8,0.5-0.7,0.8c0.1,0.4,0.4,0.4,0.9,0.3c0.7-0.1,4.6-1.9,4.8-6.1
	C150.7,111.5,145.5,105.6,136.4,105.6L136.4,105.6z M68.8,128.4c-2.9,3.2-7,4.4-8.7,3.3c-1.9-1.1-1.1-5.8,2.4-9.1
	c2.2-2,5-3.9,6.8-5.1c0.4-0.3,1-0.6,1.8-1.1c0.1-0.1,0.2-0.1,0.2-0.1c0.1-0.1,0.3-0.2,0.5-0.3C73.1,120.9,71.8,125.1,68.8,128.4
	L68.8,128.4z M90,114c-1,2.5-3.1,8.8-4.4,8.4c-1.1-0.3-1.8-5.1-0.2-9.8c0.8-2.4,2.5-5.2,3.4-6.3c1.6-1.8,3.3-2.4,3.8-1.6
	C93.1,105.6,90.6,112.5,90,114z M107.4,122.4c-0.4,0.2-0.8,0.4-1,0.3c-0.1-0.1,0.2-0.4,0.2-0.4s2.2-2.3,3.1-3.4
	c0.5-0.6,1.1-1.4,1.7-2.2v0.2C111.4,119.7,108.7,121.6,107.4,122.4L107.4,122.4z M120.9,119.3c-0.3-0.2-0.3-1,0.8-3.3
	c0.4-0.9,1.4-2.4,3-3.9c0.2,0.6,0.3,1.2,0.3,1.7C125,117.4,122.4,118.7,120.9,119.3z"
    />
  </svg>
</template>
<script>
export default {
  name: "IconSass",
};
</script>
